<template>
  <div class="container-fluid mt-4">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h3 class="card-title">Cierres Diarios</h3>
        <button id="btn-generar-cierre" class="btn btn-success" @click="ejecutarCierreDiario">
          <i class="fas fa-plus"></i> Generar Cierre de Hoy
        </button>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table v-if="!cargando" class="table table-bordered table-striped table-hover">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Total Ventas</th>
                <th>Cant. Ventas</th>
                <th>Usuario</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="cierre in cierres" :key="cierre.id_cierre">
                <td>{{ cierre.fecha_cierre }}</td>
                <td>{{ formatCurrency(Number(cierre.cierreventas.total_credito) + Number(cierre.cierreventas.total_contado)) }}</td>
                <td>{{ Number(cierre.cierreventas.cantidad_contado) + Number(cierre.cierreventas.cantidad_credito) }}</td>
                <td>{{ cierre.usuario ? cierre.usuario.name : 'N/A' }}</td>
                <td>
                  <button class="btn btn-danger btn-sm" @click="descargarPDF(cierre.id_cierre)">
                    <i class="fas fa-file-pdf"></i> PDF
                  </button>
                </td>
              </tr>
              <tr v-if="cierres.length === 0">
                <td colspan="5" class="text-center">No hay cierres registrados.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { tutorial } from "@/plugins/tutorial";
import { loading } from '@/plugins/loading';
import { alert } from '@/plugins/alert';

export default {
  name: "CierresComponent",
  data() {
    return {
      cierres: [],
    };
  },
  methods: {
    async obtenerCierres() {
      try {
        loading.show("Cargando cierres...");
        const response = await api.get("/cierres-diarios");
        this.cierres = response.data;
      } catch (error) {
        console.error("Error al obtener cierres:", error);
      } finally {
        loading.hide();
      }
    },
    async ejecutarCierreDiario() {
      const result = await alert.show({
        title: "¿Seguro que quieres ejecutar el cierre diario?",
        text: "Esta acción procesará las ventas del día actual.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, ejecutar",
      });

      if (result.isConfirmed) {
        try {
          loading.show("Procesando cierre diario...");
          // 1. Ejecutar el cierre (POST) - Esperamos JSON con el ID
          const response = await api.post("/cierre-diario");
          
          if (response.data && response.data.id_cierre) {
            const idCierre = response.data.id_cierre;
            
            // 2. Descargar el PDF (GET) - Esperamos Blob
            const pdfResponse = await api.get(`/reportes/cierre-diario/${idCierre}`, {
              responseType: "blob"
            });

            const url = window.URL.createObjectURL(
              new Blob([pdfResponse.data], { type: "application/pdf" })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `cierre_diario_${idCierre}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            
            this.$toast({
              icon: "success",
              title: "¡Éxito!",
              text: "Cierre generado exitosamente.",
            });
            this.obtenerCierres();
          }
        } catch (err) {
          console.error(err);
          const msg = err.response?.data?.message || "Error al ejecutar el cierre diario.";
          alert.show({ title: "Error", text: msg, icon: "error" });
        } finally {
          loading.hide();
        }
      }
    },
    async descargarPDF(id) {
      try {
        loading.show("Generando PDF...");
        const response = await api.get(`/reportes/cierre-diario/${id}`, {
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `cierre_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        loading.hide();
      } catch (error) {
        console.error("Error al descargar el PDF:", error);
        loading.hide();
        alert.show({ icon: "error", title: "Error", text: "No se pudo generar el PDF." });
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("es-VE", {
        style: "currency",
        currency: "USD",
      }).format(value);
    },
    iniciarTutorial() {
      const steps = [
        {
          element: '#btn-generar-cierre',
          title: 'Generar Cierre',
          text: 'Haz clic aquí para procesar las ventas del día y generar un nuevo cierre.',
          position: 'bottom'
        },
        {
          element: '.table',
          title: 'Historial de Cierres',
          text: 'Aquí puedes ver todos los cierres realizados anteriormente.',
          position: 'top'
        },
        {
          element: '.btn-danger.btn-sm',
          title: 'Descargar Reporte',
          text: 'Usa este botón para descargar el comprobante del cierre en formato PDF.',
          position: 'left'
        }
      ];

      const table = window.$('.table');
      const isCollapsed = table.hasClass('collapsed');
      const actionsVisible = table.find('tbody tr:first-child td:last-child').is(':visible');

      if (isCollapsed && !actionsVisible) {
        const firstRow = table.find('tbody tr:first-child');
        if (firstRow.hasClass('parent')) {
          const control = firstRow.find('.dtr-control');
          if (control.length) control.click();
          else firstRow.find('td:first-child').click();
        }

        steps.push({
          element: '.table tbody tr:first-child td:first-child',
          title: 'Ver Detalles',
          text: 'En pantallas pequeñas, haz clic en la primera columna para ver las acciones ocultas.',
          position: 'bottom',
          tooltipClass: 'hide-next-btn'
        });

        firstRow.off('click.tutorial');
        firstRow.on('click.tutorial', function () {
          setTimeout(() => {
            const tooltip = document.querySelector('.introjs-tooltip');
            if (!tooltip) return;
            if (window.$(this).hasClass('parent')) {
              tooltip.classList.remove('hide-next-btn');
            } else {
              tooltip.classList.add('hide-next-btn');
            }
          }, 200);
        });
      }

      tutorial.start(steps);
    }
  },
  mounted() {
    this.obtenerCierres();
    tutorial.set(this.iniciarTutorial);
  },
};
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table th {
  background-color: rgba(0, 0, 0, 0.05);
}
/* Ajustes para modo oscuro si el body tiene clase dark-mode o similar */
:deep(.dark-mode) .table, .table-dark {
  color: #fff;
}
.btn-sm {
  margin-right: 5px;
}
.hide-next-btn .introjs-nextbutton {
  display: none !important;
}
</style>
